import type { ReactNode } from "react"

interface WeeklyGoalItemProps {
  icon: ReactNode
  iconBg?: string
  title: string
  description: string
  progress: number
  completed: number
  total: number
}

export function WeeklyGoalItem({ icon, iconBg = "bg-indigo-100", title, description, progress, completed, total }: WeeklyGoalItemProps) {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-4">
      <div className={`w-16 h-16 ${iconBg} rounded-lg flex items-center justify-center shrink-0`}>{icon}</div>
      <div className="flex-grow">
        <p className="font-bold text-slate-900">{title}</p>
        <p className="text-sm text-slate-600">{description}</p>
        <div className="flex items-center gap-3 mt-2">
          <div className="flex-grow bg-slate-200 rounded-full h-2.5">
            <div
              className="bg-teal-500 h-2.5 rounded-full transition-all duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
          <span className="text-sm font-semibold text-slate-600">
            {completed}/{total}
          </span>
        </div>
      </div>
    </div>
  )
}
